import * as __WEBPACK_EXTERNAL_MODULE__useEventListener_js_908aa4fa__ from "./useEventListener.js";
var __webpack_exports__useEventListener = __WEBPACK_EXTERNAL_MODULE__useEventListener_js_908aa4fa__["default"];
export { __webpack_exports__useEventListener as useEventListener };
